import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { JsonLd } from './JsonLd';
import { breadcrumbSchema, pageBreadcrumbItems } from '../lib/jsonld';
import type { Lang } from '../lib/routes';

export function BreadcrumbJsonLd() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const lang: Lang = i18n.language === 'en' ? 'en' : 'fr';

  const items = pageBreadcrumbItems(pathname, lang);
  if (!items) return null;

  return <JsonLd data={breadcrumbSchema(items)} />;
}
